import { render, staticRenderFns } from "./CargoReports.vue?vue&type=template&id=5e8f1f66&"
import script from "./CargoReports.vue?vue&type=script&lang=js&"
export * from "./CargoReports.vue?vue&type=script&lang=js&"
import style0 from "./CargoReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoReports.vue"
export default component.exports